var _defs, _rect, _path, _path2, _path3, _path4, _path5, _ellipse, _g, _g2, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImpactedDistal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 323.5 558.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #0c9748;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-2, .cls-4 {\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #e6e6e5;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke: #009700;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke-width: 2.5px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.5,
    y: 10.76,
    width: 320.5,
    height: 543,
    rx: 36.81,
    ry: 36.81
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M73.34,227.38c-.99-36.48-5.91-65.25-10.43-85.27-8.9-39.48-19.95-61.61-10.43-85.27,4.97-12.34,15.67-25.4,26.06-24.36,5.24.52,11.65,4.76,26.06,36.54,13.86,30.54,11.49,34.45,20.85,54.81,16.73,36.41,31.65,39.92,39.1,70.04,3.97,16.06,3.52,30.36,2.61,39.59-10.71,3.51-27.01,7.31-46.92,6.09-20.34-1.25-36.5-7.25-46.92-12.18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.32,187.56c-13.93-20.71-29.36-49.84-36.49-85.27-3.36-16.7-3.83-29.56,0-42.63,1.55-5.3,7.55-25.76,20.85-30.45,20.83-7.35,51.22,26.94,57.34,60.91,1.42,7.9.95,17.45,0,36.54-1.16,23.3-3.43,42.23-5.21,54.81-5.21,6.09-10.43,12.18-15.64,18.27-6.95-4.06-13.9-8.12-20.85-12.18Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M234.94,230.2c7.59-11.06,24.73-39.27,26.06-79.18,1-29.89-7.37-51.61-15.64-73.09-7.16-18.6-12.79-32.71-26.06-42.63-16.11-12.04-38.03-13.82-41.7-6.09-2.66,5.6,6.22,12.06,10.43,30.45,2.02,8.82,1.49,13.97,0,36.54-3.36,50.91-2.5,52.29-5.21,60.91-2.81,8.95-8.46,22.47-20.85,36.54v42.63c10.62.88,22.91,1.12,36.49,0,13.73-1.13,25.99-3.43,36.49-6.09Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M88.98,345.92c-4.93-3.31-10.22-7.32-15.64-12.18-11.45-10.27-19.94-21.16-26.06-30.45.26-8.72,1.32-21.64,5.21-36.54,5.19-19.86,7.96-30.44,15.64-36.54,14.72-11.69,29.14,7.62,67.77,6.09,17.6-.7,14.38-4.7,36.49-6.09,11.53-.72,18.66-.03,57.34,0,2.22,0,4.05,0,5.21,0,7.04,4.76,21.12,15.81,31.28,36.54,7.05,14.41,9.49,27.93,10.43,36.54-5.61,6.81-14.2,16-26.06,24.36-12.87,9.07-43.97,31-67.77,18.27-17.58-9.4-19.1-31.25-31.28-30.45-9.72.64-11.78,14.77-26.06,24.36-12.38,8.32-26.15,7.99-36.49,6.09Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.44,227.51s3.51-4.25,24.19,3.27c0,0,22.85,8.44,46.2,4.69,0,0,5.5-.93,8.32-1.87,0,0,6.97-2.58,15.71-3.17,0,0,6.85-.59,15.31-.59h51.7s-77.53,73.35-161.44-2.33Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 161.75,
    cy: 451.77,
    rx: 115.08,
    ry: 84.99
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 78.9,
    y1: 392.32,
    x2: 116.56,
    y2: 418.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 207.08,
    y1: 483.76,
    x2: 245.97,
    y2: 510.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 246.23,
    y1: 393.26,
    x2: 205.71,
    y2: 418.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 112.08,
    y1: 481.44,
    x2: 71.57,
    y2: 506.77
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 160.95,
    cy: 451.35,
    rx: 62.95,
    ry: 46.48
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 211.15,
    y: 132.85,
    width: 90.71,
    height: 1.68,
    rx: 0.5,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.94,154.62l-26.51-22.25c-.2-.17-.5-.14-.66.06l-.48.57c-.17.2-.14.5.06.66l26.51,22.25c.2.17.5.14.66-.06l.47-.49c.17-.2.15-.58-.05-.74Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 206.45,
    y: 119.45,
    width: 35.55,
    height: 1.68,
    rx: 0.5,
    ry: 0.5,
    transform: "translate(-19.38 193.78) rotate(-45)"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 160.95,
    y1: 405.11,
    x2: 160.95,
    y2: 496.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpactedDistal);
export default __webpack_public_path__ + "static/media/ImpactedDistal.a6b6d0e7821a8fa77afda83dc4ff5d27.svg";
export { ForwardRef as ReactComponent };